import { createContext, useContext } from 'react';

export type RadioState = {
  value: string | number | boolean | null;
  focus?: string | number | boolean;
  disabled?: boolean;
  setFocus: (value: string | number | boolean) => void;
  setValue: (value: string | number | boolean) => void;
};

export const RadioContext = createContext<RadioState>({
  value: null,
  setFocus() {},
  setValue() {},
});

export const RadioContextProvider = RadioContext.Provider;
export const useRadio = (): RadioState => useContext(RadioContext);
